// emoji-picker-react hardcodes an unversioned jsDelivr URL that floats to `latest`.
// Bump this deliberately alongside any library upgrade.
const EMOJI_CDN_BASE = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@16.0.0/img/apple/64/";

const UNIFIED_CODEPOINT = /^[0-9a-f]+(-[0-9a-f]+)*$/i;

export const isEmojiCodepoint = (value: string): boolean => UNIFIED_CODEPOINT.test(value);

export const getPinnedEmojiUrl = (unified: string): string =>
  isEmojiCodepoint(unified) ? `${EMOJI_CDN_BASE}${unified}.png` : "";

export const getEmojiCharacter = (unified: string): string =>
  isEmojiCodepoint(unified) ? String.fromCodePoint(...unified.split("-").map((hex) => Number.parseInt(hex, 16))) : "";
